const { getElement } = window.BAO.Utils

export class SiteDrawer extends window.BAO.CustomElement({
  SuperClass: HTMLDialogElement,
}) {
  constructor () {
    super()

    this.drawers = getElement('site-drawers')
    if (!this.drawers) {
      throw new Error(
        `${this.nodeName.toLowerCase()} needs a <site-drawers> element to work`,
      )
    }

    this.inert = true
    this._isOpen = false
  }

  connectedCallback () {
    super.connectedCallback()
  }

  get key () {
    return this.getAttribute('key')
  }

  get elements () {
    return {
      trigger: getElement(`[data-drawers-trigger=${this.key}]`),
      close: getElement(`[data-module-drawers-close=${this.key}]`),
    }
  }

  get isOpen () {
    return this._isOpen
  }

  set isOpen (val) {
    this._isOpen = val

    this.classList.toggle(this.config.classes.activeDrawerClass, val)

    if (val) {
      if (!this.hasAttribute('open')) {
        this.inert = false
        this.showModal()

        this.focusOnOpen()
      }
    } else {
      if (this.hasAttribute('open')) {
        this.inert = true
        this.close()
      }
    }
  }

  focusOnOpen () {
    const focusEl =
      this.querySelector('[data-drawer-focus]') ||
      this.querySelector('[data-drawers-close]')

    if (!focusEl) return

    const tryFocus = (attempts) => {
      if (!this.isOpen || document.activeElement === focusEl) return

      focusEl.focus({ preventScroll: true })

      if (document.activeElement !== focusEl && attempts > 0) {
        requestAnimationFrame(() => {
          if (this.contains(document.activeElement)) return

          tryFocus(attempts - 1)
        })
      }
    }

    tryFocus(30)
  }

  get config () {
    return {
      classes: {
        activeDrawerClass: 'drw-Drawer-active',
      },
    }
  }
}

customElements.define('site-drawer', SiteDrawer, { extends: 'dialog' })
